import { render } from "./MeusProjetos.vue?vue&type=template&id=a38aa4f0"
import script from "./MeusProjetos.vue?vue&type=script&lang=js"
export * from "./MeusProjetos.vue?vue&type=script&lang=js"

import "./MeusProjetos.vue?vue&type=style&index=0&id=a38aa4f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__